import { type PaginatedDocs } from 'payload';
import { type PatchedProject } from '@/types';

export const fetchProjectById = async (id: string, lang: string): Promise<PatchedProject> => {
  const body = new URLSearchParams();
  body.set('where[id][equals]', id);
  body.set('depth', '3');
  const url = `/api/projects?${body.toString()}`;

  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Accept-Language': lang,
    },
  });
  if (!response.ok || response.status >= 400 || response.status < 200) {
    throw new Error('Error fetching project');
  }
  const res = (await response.json()) as PaginatedDocs<PatchedProject>;

  return res.docs[0];
};
